const asset = (name) => `/generated/${name}.png`;

export const PROMOTIONS = [
  {
    id: "promo-1",
    title: "New-Home Post-Renovation Package",
    slug: "new-home-post-renovation",
    description: "Complete post-renovation deep clean for freshly completed homes.",
    imageUrl: asset("service_post_reno"),
    altText: "Emilio's Solutions cleaner wiping newly installed kitchen cabinetry",
    terms: "Valid for HDB / BTO / Condo units. Subject to schedule availability.",
    startDate: "2026-01-01",
    endDate: "2026-12-31",
    whatsappMessage:
      "Hi Emilio's Solutions, I would like to enquire about the New-Home Post-Renovation Package.",
    ctaLabel: "Ask About This Promotion",
    featured: true,
    active: true,
    displayOrder: 1,
  },
  {
    id: "promo-2",
    title: "Move-Out Ready — End of Tenancy",
    slug: "move-out-ready",
    description: "Handover-ready clean for tenants and landlords.",
    imageUrl: asset("service_end_tenancy"),
    altText: "Emilio's Solutions cleaner cleaning empty condo living room windows",
    terms: "For residential units up to 1,500 sqft. Add-ons priced separately.",
    startDate: "2026-01-01",
    endDate: "2026-12-31",
    whatsappMessage:
      "Hi Emilio's Solutions, I would like to enquire about the Move-Out Ready package.",
    ctaLabel: "Ask About This Promotion",
    featured: false,
    active: true,
    displayOrder: 2,
  },
  {
    id: "promo-3",
    title: "Mattress + Sofa Refresh Bundle",
    slug: "mattress-sofa-bundle",
    description: "Combine mattress and sofa cleaning for a whole-home refresh.",
    imageUrl: asset("service_sofa"),
    altText: "Emilio's Solutions cleaner extracting fabric sofa",
    terms: "Applicable to fabric upholstery only. Bookings subject to availability.",
    startDate: "2026-01-01",
    endDate: "2026-12-31",
    whatsappMessage:
      "Hi Emilio's Solutions, I would like to enquire about the Mattress + Sofa Refresh bundle.",
    ctaLabel: "Ask About This Promotion",
    featured: false,
    active: true,
    displayOrder: 3,
  },
];
